require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.5@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 499
// module chunks = 0